export const QUALITY_SCOPE = 'quality';

export const BOARD_CONFIG_KEY = 'boardConfig';
